import React, { createContext, useContext, useState } from "react";
import { setCompanyId, clearCompanyId } from "../config/appConfig";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [companyId, setCompanyIdState] = useState(
    () => localStorage.getItem("companyId") || null
  );
  const [memberId, setMemberId] = useState(
    () => localStorage.getItem("memberId") || null
  );
  const [company, setCompany] = useState(() => {
    const stored = localStorage.getItem("company");
    return stored ? JSON.parse(stored) : null;
  });
  const [member, setMember] = useState(() => {
    const stored = localStorage.getItem("member");
    return stored ? JSON.parse(stored) : null;
  });
  const [memberEmail, setMemberEmailState] = useState(
    () => localStorage.getItem("memberEmail") || null
  );

  // サインイン後に呼ぶ
  const login = (cId, memberData, companyData, email) => {
    setCompanyId(cId); // appConfig の live binding を更新
    setCompanyIdState(cId);
    setMemberId(memberData.memberId || memberData.id || "");
    setMember(memberData);
    setCompany(companyData);
    localStorage.setItem("memberId", memberData.memberId || memberData.id || "");
    localStorage.setItem("member", JSON.stringify(memberData));
    localStorage.setItem("company", JSON.stringify(companyData));
    if (email) {
      setMemberEmailState(email);
      localStorage.setItem("memberEmail", email);
    }
  };

  // ログアウト: すべてクリア
  const logout = () => {
    clearCompanyId();
    setCompanyIdState(null);
    setMemberId(null);
    setMember(null);
    setCompany(null);
    setMemberEmailState(null);
    localStorage.removeItem("memberId");
    localStorage.removeItem("member");
    localStorage.removeItem("company");
    localStorage.removeItem("memberEmail");
  };

  return (
    <AuthContext.Provider
      value={{
        companyId,
        memberId,
        company,
        member,
        memberEmail,
        isAuthenticated: !!memberId,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
